export interface Pants_data {
    id : number;

    imgurl : string;

    title : string;

    mos : string;

    font? : string;

    persent : string;

    saleprice : string;

    price : string;

    review? : string;
}

let pants:Pants_data[] = [
    {
        id : 23,

        imgurl : './img/pants/img0.jpg',
        
        title : '[패키지] 로우키 밴딩 쿨 벌룬 팬츠 2PACK CJLP7492',

        mos : '1',

        font : '',

        persent : '51%',

        saleprice : '39,800원',

        price : '82,000원',

        review : 'REVIEW : 15',
    },
    {
        id : 24,

        imgurl : './img/pants/img1.jpg',
        
        title : '하이픈 데님팬츠 블루 CJLP7523',

        mos : '2',

        font : '',

        persent : '51%',

        saleprice : '38,900원',

        price : '55,800원',

        review : 'REVIEW : 8',
    },
    {
        id : 25,

        imgurl : './img/pants/img2.jpg',
        
        title : '로너 와이드 코튼팬츠 카키 JJLP7639',

        mos : '3',

        font : '',

        persent : '23%',

        saleprice : '36,900원',

        price : '47,900원',

        review : '',
    },
    {
        id : 26,

        imgurl : './img/pants/img3.jpg',
        
        title : '라운드 하드택 하프팬츠 차콜 JISP7656',

        mos : '4',

        font : '',

        persent : '23%',

        saleprice : '32,900원',

        price : '42,800원',

        review : '',
    },
    {
        id : 27,

        imgurl : './img/pants/img4.jpg',
        
        title : '플레인(여름용) 코튼 밴딩 팬츠 모카 CJLP7509',

        mos : '5',

        font : '',

        persent : '30%',

        saleprice : '31,900원',

        price : '45,800원',

        review : 'REVIEW : 1',
    },
    {
        id : 28,

        imgurl : './img/pants/img5.jpg',
        
        title : '플레인(여름용) 코튼 밴딩 팬츠 아이보리 CJLP7509',

        mos : '6',

        font : '',

        persent : '30%',

        saleprice : '31,900원',

        price : '45,800원',

        review : 'REVIEW : 3',
    },
    {
        id : 29,

        imgurl : './img/pants/img6.jpg',
        
        title : '크러쉬 워싱 숏팬츠 베이지 MJSP7673',

        mos : '7',

        font : '',

        persent : '23%',

        saleprice : '36,900원',

        price : '48,000원',

        review : '',
    },
    {
        id : 30,

        imgurl : './img/pants/img7.jpg',
        
        title : '크러쉬 워싱 숏팬츠 올드핑크 MJSP7673',

        mos : '8',

        font : '',

        persent : '23%',

        saleprice : '36,900원',

        price : '48,000원',

        review : '',
    },
    {
        id : 31,

        imgurl : './img/pants/img8.jpg',
        
        title : '크러쉬 워싱 숏팬츠 카키 MJSP7673',

        mos : '9',

        font : '',

        persent : '23%',

        saleprice : '36,900원',

        price : '48,000원',

        review : 'REVIEW : 1',
    },
    {
        id : 32,

        imgurl : './img/pants/img9.jpg',
        
        title : '[패키지] 라운드 하드택 하프팬츠 2PACK JISP7656',

        mos : '10',

        font : '[6/20 예약배송]',

        persent : '42%',

        saleprice : '49,800원',

        price : '85,600원',

        review : 'REVIEW : 2',
    },
]

export default pants;